export const projectDataFields = {
  fr: "fr",
  frill: "frill",
  isro: "isro",
  frsz: "frsz",
  a: "a",
  l_no: "l-no",
  temp_no: "temp-no",
  fril_no: "fril-no",
  article: "article",
  r_no: "r-no",
  collection: "collection",
  series: "series",
  date: "date",
  repeat_num: "repeat-num",
  repeat_num_2: "repeat-num-2",
  repeat_num_3: "repeat-num-3",
  theme: "theme",
  target_width: "target-width",
  drawn_width: "drawn-width",
  unstretched_width: "unstretched-width",
  stretch_percent: "stretch-percent",
  stretched_width: "stretched-width",
  stitches: "stitches",
  borders: "borders",
  motif: "motif",
  band: "band",
  print: "print",
  laser: "laser",
  allover: "allover",
  gallon: "gallon",
  e_2: "e-2",
  thermocut: "thermocut",
  bluecut: "bluecut",
  visual_cut: "visual-cut",
  cutting_work: "cutting-work",
  top: "top",
  cutting_top: "cutting-top",
  no_boring: "no-boring",
  pair: "pair",
  bottom: "bottom",
  cutting_bottom: "cutting-bottom",
  cut_app_f: "cut-app-f",
  cut_app_b: "cut-app-b",
  boring: "boring",
  L_R: "L-R",
  stitch_limit: "stitch-limit",
  estimated_by: "estimated",
  discussed: "discussed",
  ex_no: "ex-no",
  time_dept: "time-dept",
  comment: "comment",
  technical_dept_comment: "technical-dept-comment",
  alternating_color: "alternating-color",
  double_thread: "double-thread",
  designer: "designer",
  drawer: "drawer",
  puncher: "puncher",
  center_embroidery: "center_embroidery",
  mock_chintz: "mock_chintz",
};

export const projectColumns = Object.keys(projectDataFields);

export const projectFieldNames = Object.values(projectDataFields);
